import type { PreviewPositionSlotListItem } from '../../types';

type PositionSlotTitleSource = Pick<
  PreviewPositionSlotListItem,
  'specializationLabel' | 'technologyLabel' | 'competencyLevel'
>;

export const buildPositionSlotTitle = (positionSlot: PositionSlotTitleSource) =>
  [positionSlot.specializationLabel, positionSlot.technologyLabel, positionSlot.competencyLevel]
    .filter(Boolean)
    .join(' ');
